import { OrganizationInfo } from "../../Contacts/schema/contacts";

/**
 * Who made a company's Competitor call, when a person did (PREC-3594).
 *
 * Returns null for an AI verdict and for every manual change made before the deciding user was
 * recorded — those are shown as AI-detected, which is what they almost always were.
 */
export const competitorDecidedByName = (row: OrganizationInfo): string | null => {
	const decidedBy = row.scoreCompanyCategoryResult?.manuallyAddedBy;

	if (!decidedBy) {
		return null;
	}

	return `${decidedBy.firstName ?? ""} ${decidedBy.lastName ?? ""}`.trim() || null;
};

/** The one-line attribution above the reasoning: how it was detected, and by whom. */
export const competitorAttributionLine = (
	ts: (key: string) => string,
	row: OrganizationInfo
): string => {
	const manual = !!row.scoreCompanyCategoryResult?.manuallyAdded;
	const detectedBy = ts(manual ? "blacklist.detectedByManual" : "blacklist.detectedByAi");
	const name = competitorDecidedByName(row);

	return name ? `${detectedBy} · ${name}` : detectedBy;
};
